import React from 'react';
import { formatSoles } from '../../Global';

class PreventaModalDescuentos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            descuento: 0,
        }

        this.onChangeDescuento = this.onChangeDescuento.bind(this);
        this.fetchDescuentoPredefinido = this.fetchDescuentoPredefinido.bind(this);
        this.calculateDiscountFromProps = this.calculateDiscountFromProps.bind(this);
        this.convertToCentimos = this.convertToCentimos.bind(this);
    }

    // Convertir de soles a centimos (multiplicar por 100)
    convertToCentimos(soles) {
        return Math.round(soles * 100);
    }

    async componentDidMount() {
        let descuentoEnCentimos = this.calculateDiscountFromProps();

        if (descuentoEnCentimos === 0) {
            const descuentoSoles = await this.fetchDescuentoPredefinido();
            // Convertir el descuento predefinido de soles a centimos
            descuentoEnCentimos = this.convertToCentimos(descuentoSoles);
        }

        // Convertir a soles para mostrar en el input
        const descuentoEnSoles = formatSoles(descuentoEnCentimos);
        this.setState({ descuento: descuentoEnSoles });
        
        // Pasar el valor en centimos al componente padre
        this.props.DescuentoChange({
            target: { value: descuentoEnCentimos }
        }, this.props.ItemDescuento);
    }

    componentWillUnmount() {
        this.props.onBlurDescuento(null, this.props.ItemDescuento)
    }
    
    calculateDiscountFromProps() {
        const item = this.props.ItemDescuento;
        const { Descuento, Cantidad } = item;

        if (Descuento == 0) {
            return 0;
        }

        // Descuento ya está en centimos, devolver el descuento por unidad en centimos
        return (Descuento / Cantidad); 
    }

    async fetchDescuentoPredefinido() {
        const idPresentacion = this.props.ItemDescuento.IdPresentacion;

        const req = await fetch(`/api/presentaciones/${idPresentacion}/descuento-predefinido?validate=true`);

        if (!req.ok) {
            return 0;
        }

        const { Descuento } = await req.json();

        return Descuento; // Este Descuento viene en soles desde el API
    }

    onChangeDescuento(valorEnSoles) {
        // Convertir el valor ingresado por el usuario (soles) a centimos
        const valorEnCentimos = this.convertToCentimos(valorEnSoles);
        
        // Convertir el total de descuento (centimos) a soles para mostrar en el input de total
        const descuentoPorUnidadEnCentimos = valorEnCentimos;
        const descuentoTotalEnCentimos = descuentoPorUnidadEnCentimos * this.props.ItemDescuento.Cantidad;

        this.setState({
            descuento: valorEnSoles
        }, () => {
            // Pasar el valor en centimos al componente padre
            this.props.DescuentoChange({
                target: { value: descuentoTotalEnCentimos }
            }, this.props.ItemDescuento);
        });
    }

    render() {
        const item = this.props.ItemDescuento;
        const afectsIgv = this.props.afectsIgv;
        
        const descuentoTotalEnSoles = formatSoles(item.Descuento);

        return (
            <div className="m-3">
                <div className="row form-group col-12">
                    {this.props.ItemDescuento.descripcion}
                </div>
                <div className="row">
                    <div className="col-12 col-md-5 form-group">
                        <label>{`Dscto X ${item.unidadMedida} (S/.)`}</label>
                        <input
                            type="number"
                            readOnly={this.props.load}
                            disabled={this.props.load}
                            step="0.01"
                            min="0"
                            onClick={e => e.target.select()}
                            className='form-control'
                            value={this.state.descuento}
                            onChange={e => this.onChangeDescuento(parseFloat(e.target.value) || 0)}
                            onBlur={e => this.props.onBlurDescuento(e, this.props.ItemDescuento)}
                        />
                    </div>

                    <div className="col-12 col-md-3 form-group">
                        <label>Cantidad </label>
                        <input
                            type="number"
                            className='form-control'
                            readOnly={true}
                            disabled={true}
                            value={item.Cantidad}
                        />
                    </div>

                    <div className="col-12 col-md-4 form-group">
                        <label>Total dscto. (S/.)</label>
                        <input
                            type="number"
                            className='form-control'
                            readOnly={true}
                            disabled={true}
                            value={descuentoTotalEnSoles}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-12">
                        <label className="mr-2 mt-1" htmlFor="customCheckDescuento">¿Gratuito?</label>

                        <select className="form-control"
                                value={afectsIgv.find(i => String(i.IdAfectacionIgv === String(item.IdAfectacionIgv))) ? item.IdAfectacionIgv : "-1"}
                                onChange={e => this.props.onChangeCheckBoxGratuito(e, this.props.ItemDescuento)}
                                disabled={this.props.load}>
                                <option key={"afec-igv--1"} value="-1">No</option>
                                {afectsIgv.map(a => <option key={`afec-igv-${a.IdAfectacionIgv}`} value={a.IdAfectacionIgv}>{a.Descripcion.replace('Gravado', '')}</option>)}
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}

export default PreventaModalDescuentos